var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{ref:"veVideo",staticClass:"vue-video",attrs:{"options":_vm.playerOptions},on:{"error":_vm.onError,"ended":_vm.onPlayerEnded}})
}
var staticRenderFns = []

export { render, staticRenderFns }